const api = {
    baseApi: "https://fakestoreapi.com"
}

export default api;